"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FaviconLink = void 0;
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
const FaviconLink = ({
  version,
  staticStorageUrl
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)("link", {
  rel: "icon",
  href: (0, _utils.createStaticAssetUrl)(staticStorageUrl, version, {
    assetName: `favicon.ico`,
    blobPrefix: 'favicons/online'
  }),
  crossOrigin: "anonymous"
});
exports.FaviconLink = FaviconLink;
